import './ScrollShadow.scss';
import { useOnMount } from '@hooks';
import React, { useRef } from 'react';
export const ScrollShadow = ({ children, scroller, shadow }) => {
    const containerRef = useRef(null);
    useOnMount(() => {
        var _a, _b, _c, _d;
        (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(scroller)) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', (e) => {
            var _a;
            const shadowTarget = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(shadow);
            if (!shadowTarget) {
                return;
            }
            shadowTarget.classList.toggle('drop-shadow', e.target.scrollTop > 0);
        });
        (_d = (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.querySelector(shadow)) === null || _d === void 0 ? void 0 : _d.classList.add('scroll-shadow');
    });
    if (!children) {
        return null;
    }
    return React.cloneElement(children, { ref: containerRef });
};
